import BaseService from "./base.service";

export default class CartAnalyticsService extends BaseService {
  constructor() {
		super('CartAnalytics');
	}

  saveAnalytics(cartId) {
		var trackings = JSON.parse(localStorage.getItem('trackings'));
		console.log(trackings)
		if (trackings) {
			localStorage.removeItem('trackings');
			return this.postRequest("SaveAnalytics", {
					trackings,
					cartId,
			});
		}
		else
			return
  }
}